<!-- PDF查看组件 -->
<template>
    <el-row :style="styleInfo">
      <!-- <i class="el-icon-circle-check details_success" v-if="studentScore == questionScore" ></i> -->
      <i class="el-icon-circle-check details_success" v-if="studentScore > 0" ></i>
      <i class="el-icon-circle-close details_error" v-else></i>
    </el-row>
</template>

<script>
export default {
  name: "IconInfo",
  props: {
    studentScore: {
      type: Number,
      default: function(){
        return 0;
      }
    },
    questionScore: {
      type: Number,
      default: function(){
        return 0;
      }
    },
    styleInfo: {
      type: Object,
      default: function(){
        return {'float':'left','display':'none'}; //先隐藏吧，不是相要的效果
      }
    },
  },
  data() {
    return {

    };
  },
  created() {

  },
  mounted() {

  },
  methods: {

  }
};
</script>

<style lang="less">
.details_error{
  opacity: 0.8;
  font-size: 45px;
  color: red;
  margin-right: 12px;
  float: left;
  z-index: 1;
  margin-top: -14px;
}

.details_success{
  opacity: 0.8;
  font-size: 45px;
  color: #409eff;
  margin-right: 12px;
  float: left;
  z-index: 1;
  margin-top: -14px;
}
</style>



// WEBPACK FOOTER //
// src/components/iconInfo.vue